import { Pipe, PipeTransform } from '@angular/core';
import { PayloadType } from '../models/entities/payload-type';

@Pipe({
  name: 'payloadType'
})
export class PayloadTypePipe implements PipeTransform {

  transform(value: string, args: PayloadType[]): any {
    if (!value || !args) return null;
    const result = args.find(el => el?.payloadType?.toLowerCase() === value?.toLowerCase());

    if (result) return result.description;
    return null;
  }
}
